/* eslint-disable @typescript-eslint/no-unused-vars */

/**
 * This code is used to get the LLC new deals and update the status of the deal
 * Mostly rewritten from llcfuncs.js
 */
import { MakeXMLString, xmlFormatXPathConstant } from "../util/rpwCommonFuncs";

var llcDomain = "", llcSiteType = "", drLLCMsgUrl = "";
var llcNewDealsUrl = "";
llcNewDealsUrl = process.env.REACT_APP_OLD_DR_ENDPOINT + "/Purplusweb/GetLLCMsg.asp";

if (window.location.href.indexOf("www.lawyerdonedeal.com/rplus/") != -1 || window.location.href.indexOf("chrome.lawyerdonedeal.com/rplus/") != -1) {
    // live
    llcDomain = "https://fctexintgpr10.firstcdn.com/lawyerintegrationgateway/v1";
    llcSiteType = "prod";
    drLLCMsgUrl = process.env.REACT_APP_DSAPI_ENDPOINT + "/dr/Purplusweb/llcMsg.asp";
}
else if (window.location.href.indexOf("www2.lawyerdonedeal.com/rplus/") != -1 || window.location.href.indexOf("chrome.lawyerdonedeal.com/rplustest/") != -1) {
    // rplustest
    llcDomain = "https://fctexintgsg10.prefirstcdn.com/lawyerintegrationgateway/v1";
    llcSiteType = "test";
    drLLCMsgUrl = process.env.REACT_APP_DSAPI_ENDPOINT + "/dr/Purplusweb/llcMsg.asp";
}
else {
    // uat or local
    llcDomain = "https://fctexintgsg10.prefirstcdn.com/lawyerintegrationgateway/v1"; //"https://cloud.lawyerdonedeal.com/fcttestsite";
    llcSiteType = "test";
    drLLCMsgUrl = process.env.REACT_APP_DSAPI_ENDPOINT + "/dr/Purplusweb/llcMsg.asp";
}
var fctBusinessRoles = ["Lawyer", "Clerk", "Other"];
var thirdPartyInfo = null, llcPlatformInfo = null;
var StatusTextToCode = {
    "PENDING ACCEPTANCE": 0,
    "DECLINED": 5,
    "ACTIVE": 1,
    "COMPLETED": 2,
    "CANCELLATION REQUESTED": 3,
    "CANCELLED": 4
};

export async function getTransData(transID, LSUCID) {
    let thirdPartyInfoXML = await ieRequestXML('GetThirdPartyInfo.asp');
    let thirdPartyInfo = new ajaxslt.XDocument();
    thirdPartyInfo.loadXML(thirdPartyInfoXML);
    if (llcPlatformInfo == null) {
        var platformCallUrl = "".concat(llcDomain, "/llcresources");
        var platformURL = "localredirect.asp?url=".concat(encodeURIComponent(platformCallUrl));
        var platformHttp = await ieRequestXML(platformURL);
        llcPlatformInfo = JSON.parse(platformHttp);
    }
    var lawyer = thirdPartyInfo.documentElement.selectSingleNode("LawyerList/lawyer[@LSUCID='".concat(LSUCID, "']"));

    var xfct = getEncodedXFCT(lawyer.getAttribute('LLCUsername'));
    var callUrl = "".concat(llcDomain, "/transactions/").concat(transID);
    var url = "localredirect.asp?url=".concat(encodeURIComponent(callUrl), "&xfctAuthorization=").concat(xfct, "&authorization=").concat(lawyer.getAttribute('LLCToken'));
    //  send request
    var xmlHttp = await ieRequestXML(url, null, true);
    if (xmlHttp.status == 200) {
        var xmlHttpText = await xmlHttp.text();
        var response = JSON.parse(xmlHttpText);
        var lenderName = '', mortgageeName = '';
        if (response.lenderCode == '444' || response.lenderCode == '004' || response.lenderCode == '-44')
            lenderName = "The Toronto-Dominion Bank";
        else if (response.lenderCode == '002' || response.lenderCode == '222' || response.lenderCode == '-02') {
            if (response.mortgage && response.mortgage.registrationInstructions && response.mortgage.registrationInstructions.mortgageType && response.mortgage.registrationInstructions.mortgageType.toLowerCase() == "collateral")
                lenderName = "The Bank of Nova Scotia";
            else
                lenderName = "Scotia Mortgage Corporation";
        }
        else {
            // MMS
            for (var _i = 0, _a = llcPlatformInfo.financialInstitutions; _i < _a.length; _i++) {
                var institution = _a[_i];
                if (institution.lenderCode == response.lenderCode) {
                    lenderName = institution.nameEn;
                }
                if (institution.lenderCode == response.mortgage.mortgagee) {
                    mortgageeName = institution.nameEn;
                }
                if (response.lenderCode == response.mortgage.mortgagee && lenderName != '')
                    break;
                if (response.lenderCode != response.mortgage.mortgagee && lenderName != '' && mortgageeName != '')
                    break;
            }
        }
        response.mortgage.lenderName = lenderName;
        if (mortgageeName != '')
            response.mortgage.mortgageeName = mortgageeName;
        var xmlStr = OBJtoXML(response);
        var xmlDoc = new ajaxslt.XDocument();
        xmlDoc.loadXML("<LLCNode><LLCTransaction>".concat(xmlStr, "</LLCTransaction></LLCNode>"));
        // check any spouse is guarantor
        var mNodes = xmlDoc.documentElement.selectNodes("LLCTransaction/mortgagors[not(spouseFirstName/text()='')]");
        for (var i = 0; i < mNodes.length; i++) {
            var firstName = mNodes[i].selectSingleNode("spouseFirstName").text;
            var middleName = mNodes[i].selectSingleNode("spouseMiddleName").text;
            var lastName = mNodes[i].selectSingleNode("spouseLastName").text;
            var nameSelection = "";
            if (middleName > "") {
                nameSelection = "firstName/text()=" + xmlFormatXPathConstant(firstName) + " and middleName/text()=" + xmlFormatXPathConstant(middleName) + " and lastName/text()=" + xmlFormatXPathConstant(lastName);
            }
            else {
                nameSelection = "firstName/text()=" + xmlFormatXPathConstant(firstName) + " and lastName/text()=" + xmlFormatXPathConstant(lastName);
            }
            var gNode = xmlDoc.documentElement.selectSingleNode("LLCTransaction/guarantors[(guarantorType/text()='Person' or guarantorType/text()='PERSON') and (" + nameSelection + ")]");
            if (gNode) {
                gNode.setAttribute("isSpouse", "1");
                mNodes[i].setAttribute("isSpouseGuarantor", "1");
                mNodes[i].setAttribute("spouseLLCID", gNode.selectSingleNode('id').text);
            }
        }
        return xmlDoc.documentElement;
    }
    else {
        //console.log('Failed to get LLC new Transactions');
    }
}

function UpdateStatus(transID, LSUCID) {
    // update in tblMessage (TODO: if we want to display LLC Deals Status in Inbox)
    var llcMsgBody: any = new ajaxslt.XDocument(); 
    llcMsgBody.loadXML("<MsgBody />");
    llcMsgBody = llcMsgBody.documentElement;
    llcMsgBody.setAttribute("LLCTransID", transID);
    llcMsgBody.setAttribute("LSUCID", LSUCID);
    llcMsgBody.setAttribute("status", String(StatusTextToCode.CANCELLED));
    ieRequestXML(drLLCMsgUrl, llcMsgBody.xml, true);
}

async function ieRequestXML(url, xml?, bReturnRequestObj?) {
    // Get the current window's URL
    const currentUrl = new URL(window.location.href);

    const separator = url.includes('?') ? '&' : '?';
    const requestUrl = `${url}${separator}SessionID=${currentUrl.searchParams.get("SessionID")}`;

    let req;
    if (xml) {
        req = fetch(requestUrl.toString());
    } else {
        req = fetch(requestUrl.toString(), { 
            method: "POST", 
            body: xml, 
            headers: {
                'Content-Type': 'text/plain'
            }
        });
    }
    const res = await req;
    if (bReturnRequestObj) {
        return res;
    }   
    const resText = await res.text();
    return resText;
}

function getEncodedXFCT(lawyerLLCUsername) {
    if (lawyerLLCUsername === void 0) { lawyerLLCUsername = ""; }
    if (lawyerLLCUsername == "")
        return "USEREMPTY";
    else
        return lawyerLLCUsername;
}

function OBJtoXML(obj) {
    try {
        var xml = '';
        for (var prop in obj) {
            xml += obj[prop] instanceof Array ? '' : "<" + prop + ">";
            if (obj[prop] instanceof Array) {
                for (var array in obj[prop]) {
                    if (array != "indexOf") {
                        if (obj[prop][array] instanceof Object) {
                            xml += "<" + prop + ">";
                            xml += OBJtoXML(new Object(obj[prop][array]));
                            xml += "</" + prop + ">";
                        }
                        else {
                            xml += "<" + prop + ">";
                            xml += obj[prop][array];
                            xml += "</" + prop + ">";
                        }
                    }
                }
            }
            else if (typeof obj[prop] == "object") {
                xml += OBJtoXML(new Object(obj[prop]));
            }
            else {
                xml += MakeXMLString('' + obj[prop]);
            }
            xml += obj[prop] instanceof Array ? '' : "</" + prop + ">";
        }
        var xml = xml.replace(/<\/?[0-9]{1,}>/g, '');
        return xml;
    }
    catch (e) {
        throw e;
    }
}

async function getLLCNewDeals(SessionID: string) {
    const url = llcNewDealsUrl + "?SessionID=" + SessionID;
    const response = await fetch(url);
    const data = await response.text();
    return data;
}

export const LLCFuncs = {
    UpdateStatus,
    getTransData,
    getLLCNewDeals,
}